module.exports = __webpack_public_path__ + "static/media/loading-white.55f05ede.svg";